<h2 mat-dialog-title>
  {{ isEditMode ? 'Modifier la nomenclature' : 'Créer une nomenclature' }}
</h2>

<mat-dialog-content>
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" id="nomenclatureForm">
    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Activité UO opérationnelle</mat-label>
      <textarea
        matInput
        formControlName="activiteUOoperationnelle"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="6"
        maxlength="100"
        [errorStateMatcher]="matcher"
        placeholder="Saisissez l'activité UO opérationnelle..."
      ></textarea>
      <mat-hint>Obligatoire</mat-hint>
      <mat-hint align="end">
        {{ (formGroup.get('activiteUOoperationnelle')?.value?.length || 0) + '/100 caractères' }}
      </mat-hint>

      <mat-error *ngIf="formGroup.get('activiteUOoperationnelle')?.errors?.['required']">
        Le champ est obligatoire
      </mat-error>
      <mat-error *ngIf="formGroup.get('activiteUOoperationnelle')?.errors?.['pattern']">
        Le champ ne peut pas contenir uniquement des espaces
      </mat-error>
      <mat-error *ngIf="formGroup.get('activiteUOoperationnelle')?.errors?.['maxlength']">
        Maximum 100 caractères
      </mat-error>
      <mat-error *ngIf="errorMessage && !formGroup.get('activiteUOoperationnelle')?.errors">
        {{ errorMessage }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Label de nomenclature</mat-label>
      <input
        matInput
        formControlName="nomenclatureLabel"
        type="text"
        maxlength="100"
        [errorStateMatcher]="matcher"
      />
      <mat-hint>Obligatoire</mat-hint>
      <mat-hint align="end">
        {{ (formGroup.get('nomenclatureLabel')?.value?.length || 0) + '/100 caractères' }}
      </mat-hint>

      <mat-error *ngIf="formGroup.get('nomenclatureLabel')?.errors?.['required']">
        Le champ est obligatoire
      </mat-error>
      <mat-error *ngIf="formGroup.get('nomenclatureLabel')?.errors?.['pattern']">
        Le champ ne peut pas contenir uniquement des espaces
      </mat-error>
      <mat-error *ngIf="formGroup.get('nomenclatureLabel')?.errors?.['maxlength']">
        Maximum 100 caractères
      </mat-error>
    </mat-form-field>

    <div class="row-fields">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Prix UO</mat-label>
        <input
          matInput
          formControlName="prixUO"
          type="number"
          step="0.01"
          min="0"
          [errorStateMatcher]="matcher"
        />
        <mat-hint>Obligatoire</mat-hint>

        <mat-error *ngIf="formGroup.get('prixUO')?.errors?.['required']">
          Le champ est obligatoire
        </mat-error>
        <mat-error *ngIf="formGroup.get('prixUO')?.errors?.['min']">
          Le prix doit être supérieur ou égal à 0
        </mat-error>
        <mat-error *ngIf="formGroup.get('prixUO')?.errors?.['pattern']">
          Nombre invalide, max 2 décimales (ex: 12.34)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" color="accent">
        <mat-label>Prix UO majoré</mat-label>
        <input
          matInput
          formControlName="prixUOmajore"
          type="number"
          step="0.01"
          min="0"
          [errorStateMatcher]="matcher"
        />
        <mat-hint>Obligatoire</mat-hint>

        <mat-error *ngIf="formGroup.get('prixUOmajore')?.errors?.['required']">
          Le champ est obligatoire
        </mat-error>
        <mat-error *ngIf="formGroup.get('prixUOmajore')?.errors?.['min']">
          Le prix doit être supérieur ou égal à 0
        </mat-error>
        <mat-error *ngIf="formGroup.get('prixUOmajore')?.errors?.['pattern']">
          Nombre invalide, max 2 décimales (ex: 12.34)
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Annuler</button>
  <button
    mat-raised-button
    color="primary"
    type="submit"
    form="nomenclatureForm"
    [disabled]="!formGroup.valid"
  >
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>
</mat-dialog-actions>